/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
import { StringMap } from '@/rtk-query.gql';

export type StringMapType = Omit<StringMap, '__typename'>;

export type PrimeDropdownOption = {
  label?: string;
  value: string | null;
};

export type PrimeDropdownOptions = PrimeDropdownOption[];

export enum StringMapObjectTypeCode {
  SHIPPING_METHOD = 10089,
  SHIPMENT_STATUS = 10089,
  DRUG_SHIPPING_FEE = 10081,
  EXPORT = 10081,
  NON_EU_COUNTRY = 10019,
  FREEZE = 10081,
  IMPLANT_TYPE = 10081,
  SEMEN_TYPE = 10081,
  SHIP = 10081,
  TRANSFER = 10081,
  PROCEDURE_TIME = 10081,
  PARTNERSHIP_UI_TABS = 10168,
  DONOR_CATEGORY = 10006,
  BODY_CONDITION_SCORE = 10006,
  CALF_TYPE = 10016,
  EMBRYO_PLAN = 10028,
  RIGHT_LEFT = 10016,
  SO_SCHEDULE = 10028,
}

export const StringMapAttributeName = {
  SHIPPING_METHOD: 'tog_shippingmethod',
  SHIPMENT_STATUS: 'tog_shpmentstatus',
  DRUG_SHIPPING_FEE: 'tog_drugshipfee',
  EXPORT: 'tog_export',
  NON_EU_COUNTRY: 'tog_noneucountry',
  FREEZE: 'tog_freeze',
  IMPLANT_TYPE: 'tog_implantType',
  SEMEN_TYPE: 'tog_semenType',
  SHIP: 'tog_ship',
  TRANSFER: 'tog_transfer',
  PROCEDURE_TIME: 'tog_procedureTime',
  PARTNERSHIP_UI_TABS: 'tog_type',
  DONOR_CATEGORY: 'tog_donorcategory',
  BODY_CONDITION_SCORE: 'tog_bodyconditionscore',
  CALF_TYPE: 'tog_calftype',
  EMBRYO_PLAN: 'tog_embryoplan',
  RIGHT_LEFT: 'tog_rightleft',
  SO_SCHEDULE_FRESH: 'tog_fresh',
  SO_SCHEDULE_FSH_NEXT: 'tog_fshnext',
  SO_SCHEDULE_BILL_STATUS: 'tog_billstatus',
} as const;

export type StringMapOption = {
  objectTypeCode: StringMapObjectTypeCode;
  attributeName: (typeof StringMapAttributeName)[keyof typeof StringMapAttributeName];
};

export const StringMapOptions: Record<string, StringMapOption> = {
  DRUG_SHIPPING_FEE: {
    objectTypeCode: StringMapObjectTypeCode.DRUG_SHIPPING_FEE,
    attributeName: StringMapAttributeName.DRUG_SHIPPING_FEE,
  },
  EXPORT: {
    objectTypeCode: StringMapObjectTypeCode.EXPORT,
    attributeName: StringMapAttributeName.EXPORT,
  },
  NON_EU_COUNTRY: {
    objectTypeCode: StringMapObjectTypeCode.NON_EU_COUNTRY,
    attributeName: StringMapAttributeName.NON_EU_COUNTRY,
  },
  FREEZE: {
    objectTypeCode: StringMapObjectTypeCode.FREEZE,
    attributeName: StringMapAttributeName.FREEZE,
  },
  IMPLANT_TYPE: {
    objectTypeCode: StringMapObjectTypeCode.IMPLANT_TYPE,
    attributeName: StringMapAttributeName.IMPLANT_TYPE,
  },
  SEMEN_TYPE: {
    objectTypeCode: StringMapObjectTypeCode.SEMEN_TYPE,
    attributeName: StringMapAttributeName.SEMEN_TYPE,
  },
  SHIP: {
    objectTypeCode: StringMapObjectTypeCode.SHIP,
    attributeName: StringMapAttributeName.SHIP,
  },
  TRANSFER: {
    objectTypeCode: StringMapObjectTypeCode.TRANSFER,
    attributeName: StringMapAttributeName.TRANSFER,
  },
  PROCEDURE_TIME: {
    objectTypeCode: StringMapObjectTypeCode.PROCEDURE_TIME,
    attributeName: StringMapAttributeName.PROCEDURE_TIME,
  },
  SHIPPING_METHOD: {
    objectTypeCode: StringMapObjectTypeCode.SHIPPING_METHOD,
    attributeName: StringMapAttributeName.SHIPPING_METHOD,
  },
  SHIPMENT_STATUS: {
    objectTypeCode: StringMapObjectTypeCode.SHIPMENT_STATUS,
    attributeName: StringMapAttributeName.SHIPMENT_STATUS,
  },
  PARTNERSHIP_UI_TABS: {
    objectTypeCode: StringMapObjectTypeCode.PARTNERSHIP_UI_TABS,
    attributeName: StringMapAttributeName.PARTNERSHIP_UI_TABS,
  },
};
